import forEach from 'lodash/forEach';
import isEmpty from 'lodash/isEmpty';
import noop from 'lodash/noop';
import produce from 'immer';

import * as sharedTypes from 'src/actions/shared/sharedTypes';
import createDocumentResource, { handleStandardErrors } from 'src/actions/shared/createDocumentResource';
import emptyObserverCreator from 'src/actions/shared/emptyObserverCreator';
import { IvrTreeData } from 'src/models/Ivrs/IvrTreeData';

const ivrsTreeDataResource = createDocumentResource<IvrTreeData>({
  name: 'ivrsTreeData',
  endpoint: 'v1/orgs/:orgId/configuration/ivrs/:id/versions/:version/tree-data',
  observerCreator: emptyObserverCreator,
  type: IvrTreeData,
});

const unload: sharedTypes.AppThunk = () => noop;

const fetch: sharedTypes.AppThunk =
  (params: any) =>
  async (dispatch, getState, { gateways }) => {
    try {
      dispatch(fetchStarted({}));

      const nodeLocations = await gateways.ivrsTreeData.request(params);
      const locations = Array.isArray(nodeLocations) && !isEmpty(nodeLocations) ? nodeLocations[0] : nodeLocations;

      // BE accept coordinates x and y only as a string value
      const treeData = convertCoordinatesInTreeDataToNumbers(locations);

      dispatch(fetchSuccess({ ...treeData.positions }));
    } catch (error) {
      handleStandardErrors({ error, dispatch, handleDomainError: fetchError, handleDefaultError: fetchRequestError });
    }
  };

const replace: sharedTypes.AppThunk =
  (params: any, attrs: any) =>
  async (dispatch, getState, { gateways }) => {
    const { updateStarted } = ivrsTreeDataResource.actions;
    try {
      dispatch(updateStarted({}));

      const treeData = convertCoordinatesInTreeDataToString(attrs);
      await gateways.ivrsTreeData.replace(params, treeData);

      dispatch(fetchSuccess({ ...attrs.positions }));
      return true;
    } catch (error) {
      return false;
    }
  };

// BE accept coordinates x and y only as a string value
export const convertCoordinatesInTreeDataToString = (treeData): any => {
  return produce(treeData, draft => {
    forEach(draft.positions, key => {
      key.x = key.x.toString();
      key.y = key.y.toString();
    });
  });
};

export const convertCoordinatesInTreeDataToNumbers = (treeData): IvrTreeData =>
  produce<IvrTreeData>(treeData, draft => {
    forEach(draft.positions, key => {
      key.x = Number(key.x);
      key.y = Number(key.y);
    });
  });

ivrsTreeDataResource.effects.fetch = fetch;
ivrsTreeDataResource.effects.unload = unload;
ivrsTreeDataResource.effects.replace = replace;

const { fetchError, fetchRequestError, fetchStarted, fetchSuccess } = ivrsTreeDataResource.actions;

export default ivrsTreeDataResource;
